var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-scroll-container"},[_c('div',{staticClass:"chart-container",style:({ width: _vm.chartWidth, position: 'relative', height: '350px' })},[_c('canvas',{ref:"chart"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }